//忠诚度管理-奖品中心
import { get, post, postJson, put, putUrl } from "../axios2";

const RESOURCE_BASE_PATH = "/sellerCouponWrite";

const RESOURCE_BASE_PATH1 = "/beansPlan";

const RESOURCE_BASE_PATH2 = "/assetsPlan";

const RESOURCE_BASE_PATH3 = "/redPacketPlan";

const RESOURCE_BASE_PATH4 = "/public";

//获取当前登陆用户菜单列表 
export const getMenuList = (p) => get(`/menus`, p)

//查询优惠券列表
export const couponList = (p) => postJson(`${RESOURCE_BASE_PATH}/list`, p);

//查询京豆
export const jingdouList = (p) => postJson(`${RESOURCE_BASE_PATH1}/list`, p);


//查询京豆发放明细
export const jingdouRecordList = (p) =>
  postJson(`${RESOURCE_BASE_PATH1}/record/list`, p);

//查询京豆账户余额
export const jingdouAccount = (p) =>
  get(`${RESOURCE_BASE_PATH1}/accountBalance`, p);

//创建京豆
export const jingdouSet = (p) => postJson(`${RESOURCE_BASE_PATH1}`, p);

//京豆详情回显
export const jignduoEcho = (id) => get(`${RESOURCE_BASE_PATH1}/detail/${id}`);

//查询账户余额
export const allAccount = (p) =>
  get(`${RESOURCE_BASE_PATH2}/accountBalance/list`, p);

//查询京东E卡,爱奇艺会员,京豆PLUS会员
export const allAccountList = (p) => postJson(`${RESOURCE_BASE_PATH2}/list`, p);

//创建京东E卡,爱奇艺会员,京豆PLUS会员
export const setAccountList = (p) => postJson(`${RESOURCE_BASE_PATH2}`, p);

//修改资产
export const modifyAssets = (p) => put(`${RESOURCE_BASE_PATH2}`, p);



//获取资产发放明细
export const getAccountList = (p) =>
  postJson(`${RESOURCE_BASE_PATH2}/record/list`, p);

//查询红包
export const redPacketList = (p) => postJson(`${RESOURCE_BASE_PATH3}/list`, p);

//创建红包
export const setRedPacket = (p) => postJson(`${RESOURCE_BASE_PATH3}`, p);

//红包发放明细
export const dispenseRedPacket = (p) =>
  postJson(`${RESOURCE_BASE_PATH3}/record/list`, p);

//停止红包
export const stopRedPacket = (id) => putUrl(`${RESOURCE_BASE_PATH3}/stop/${id}`);

//停止京豆计划
export const stopActivity = (id) => putUrl(`${RESOURCE_BASE_PATH1}/stop/${id}`);
//停止资产
export const stopAssets = (id) => putUrl(`${RESOURCE_BASE_PATH2}/stop/${id}`);

//判断是否开通积分
export const judgingActivation = (p) =>
  get(`${RESOURCE_BASE_PATH4}/isPointsEnabled`, p);


  
  
